export default "__VITE_ASSET__DAfn9$ut__"